import { render, staticRenderFns } from "./photoSee.vue?vue&type=template&id=644c7cb0&scoped=true"
import script from "./photoSee.vue?vue&type=script&lang=js"
export * from "./photoSee.vue?vue&type=script&lang=js"
import style0 from "./photoSee.vue?vue&type=style&index=0&id=644c7cb0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644c7cb0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('644c7cb0')) {
      api.createRecord('644c7cb0', component.options)
    } else {
      api.reload('644c7cb0', component.options)
    }
    module.hot.accept("./photoSee.vue?vue&type=template&id=644c7cb0&scoped=true", function () {
      api.rerender('644c7cb0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ReportManagement/DeliveryLoading/component/photoSee.vue"
export default component.exports